import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'
import {useTranslation} from 'react-i18next'
import {useFetchAccessMenu} from '../../../../hooks/useFetchAccessMenu'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {filterSelector, setFilterNews} from '../../../../redux/slices/filterSlices'
import {StyledButtonGroups} from '../../../../components/StyledButtonGroups'
import {appSelector} from '../../../../redux/slices/appSlices'
import {HakAkses} from '../../../../components/mikro/getHakAkses'

export const ButtonGroups = () => {
  const {t} = useTranslation()
  const {accesses} = useFetchAccessMenu()
  const {filterNews: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()
  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterNews({...filter, per_page: value ?? 5}))
  }

  if (!accesses) return null

  return (
    <StyledButtonGroups
      leftContent={
        <SelectPageSize
          initialValue={filter?.per_page ?? 5}
          onChange={(value: any) => handlePageSizeChange(value?.value)}
        />
      }
      rightContent={
        <>
          {hakAkses?.create && (
            <Link to='/content/news/create'>
              <button className='btn btn-primary d-flex align-items-center'>
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                <p>{t('order-tambah')}</p>
              </button>
            </Link>
          )}
        </>
      }
    />
  )
}
